import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckSquare, Scissors, Moon, HelpCircle, Plane } from 'lucide-react';
export function WhatIncludes() {
  const items = [{
    icon: BookOpen,
    title: 'Ebook guía',
    desc: 'Paso a paso, las 7 noches detalladas.'
  }, {
    icon: CheckSquare,
    title: 'Imprimibles',
    desc: 'Checklist de 7 noches + registro diario de progreso.'
  }, {
    icon: Scissors,
    title: 'Tarjetas recortables',
    desc: 'Frases listas para tener en la mesa de luz (Corte + Puente).'
  }, {
    icon: Moon,
    title: 'Plan de despertares',
    desc: 'Modo simple y avanzado para la madrugada.'
  }, {
    icon: HelpCircle,
    title: 'Solución de problemas',
    desc: "Miedos, agua, pipí, madrugar, 'no tengo sueño'."
  }, {
    icon: Plane,
    title: 'Mantenimiento',
    desc: 'Qué hacer en viajes, enfermedades o regresiones.'
  }];
  return <section className="py-24 px-6 bg-[#14142B] text-[#F5F0E8]" data-id="element-217">
      <div className="max-w-5xl mx-auto" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-219">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-white" data-id="element-220">
            Qué incluye exactamente{' '}
            <span className="text-[#D4A574]" data-id="element-221">"Dormí Hoy"</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-222">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#1C1C2E] p-6 rounded-xl border border-[#F5F0E8]/5 hover:border-[#D4A574]/30 transition-all hover:-translate-y-1 group" data-id="element-223">
              <div className="w-12 h-12 rounded-full bg-[#14142B] border border-[#D4A574]/20 flex items-center justify-center mb-4 group-hover:bg-[#D4A574]/10 transition-colors" data-id="element-224">
                <item.icon className="w-6 h-6 text-[#D4A574]" data-id="element-225" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-226">
                {item.title}
              </h3>
              <p className="text-[#F5F0E8]/70 text-sm" data-id="element-227">{item.desc}</p>
            </motion.div>)}
        </div>

        {/* Bonus Item */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-8 bg-[#5A8A7A]/10 p-6 rounded-xl border border-[#5A8A7A]/30 flex items-center justify-center gap-4 max-w-2xl mx-auto" data-id="element-228">
          <div className="bg-[#5A8A7A] text-[#1C1C2E] text-xs font-bold px-2 py-1 rounded uppercase" data-id="element-229">
            Bonus
          </div>
          <p className="font-medium text-[#F5F0E8]" data-id="element-230">
            Mini-plan de pantallas tarde (3 pasos para desintoxicar la tarde)
          </p>
        </motion.div>
      </div>
    </section>;
}